<form [formGroup]="signUpForm" name="signUpForm" (ngSubmit)="signUpForm.valid && register()" class="s-signUpForm">
  <div class="">
    <ng-container *ngIf="isAcmic; else maOrLegacy">
      <mapfre-validation [input]="inputs[4]" [form]="signUpForm"
        [ngClass]="{'acmic-signup-label':isAcmic}"></mapfre-validation>
      <div *ngFor="let input of inputs; index as index; " class="input" [ngClass]="{'acmic-signup-label':isAcmic}">
        <mapfre-validation [input]="input" [form]="signUpForm"
          *ngIf="input?.key !== 'addPolicyOnSignUp'"></mapfre-validation>
      </div>
    </ng-container>
    <ng-template #maOrLegacy>
      <div class="input">
        <mapfre-validation [input]="inputs[4]" [form]="signUpForm"
          [ngClass]="{ 'policy-field': !isAcmic }"></mapfre-validation>
        <div class="policy-find-info mt-24">
          <img src="assets/img/images/icon-info-red.svg"
            alt="info icon" /><app-find-policy-info-modal></app-find-policy-info-modal>
        </div>
      </div>
      <ng-container *ngFor="let input of inputs;index as index;">
        <div class="input" *ngIf="input?.key !== 'addPolicyOnSignUp'" [ngClass]="{'margin-top mt24':index === 0}">
          <mapfre-validation [input]="input" [form]="signUpForm"></mapfre-validation>
        </div>
      </ng-container>

    </ng-template>
  </div>

  <div class="disclaimer disclaimer-small-size legal mt-0 mb-3" [ngClass]="{'create-account-disclaimer': isAcmic}">
    {{ 'CREATE_ACCOUNT_LEGAL_ONE' | translate }}
    <ng-container *ngIf="isAcmic; else maState">
      <a href="https://wa.aaa.com/insurance/aaainsurance/terms-conditions.html" target="_blank" rel="noopener">{{
        'CREATE_ACCOUNT_LEGAL_TWO' | translate }}</a>
      {{ 'CREATE_ACCOUNT_LEGAL_THREE' | translate }}
      <a href="https://wa.aaa.com/insurance/aaainsurance/privacy-policy.html" target="_blank" rel="noopener">{{
        'CREATE_ACCOUNT_LEGAL_FOUR' | translate }}</a>
    </ng-container>
    <ng-template #maState>
      <a class="corporate-red" href="https://www.mapfreinsurance.com/en/terms-conditions/" target="_blank"
        rel="noopener">{{ 'CREATE_ACCOUNT_LEGAL_TWO' | translate }}</a>
      {{ 'CREATE_ACCOUNT_LEGAL_THREE' | translate }}
      <a class="corporate-red" href="https://www.mapfreinsurance.com/en/privacy-policy/" target="_blank"
        rel="noopener">{{ 'CREATE_ACCOUNT_LEGAL_FOUR' | translate }}</a>
    </ng-template>
  </div>
  <div class="text-center" [ngClass]="{ 'cc-ac-continue-btn': isAcmic }">
    <mapfre-button [ngClass]="{'custom_loader':loader}" [additionalClasses]="'basic primary large-btn'"
      [disabledValue]="signUpForm.valid && !loader" [inputType]="'submit'"
      [translateValue]="'CONTINUE' | translate"></mapfre-button>
  </div>
</form>